import {DROPDOWN_VISIBLE, DROPDOWN_NOT_VISIBLE} from "../constants/actionTypes";

export const dropdownVisibleAction = () => ({
    type: DROPDOWN_VISIBLE
});

export const dropdownNotVisibleAction = () => ({
    type: DROPDOWN_NOT_VISIBLE
});